import { useTranslation } from 'react-i18next';

const CARDS = [
  { icon: 'ri-table-line', titleKey: 'value.c1.title', descKey: 'value.c1.desc' },
  { icon: 'ri-store-line', titleKey: 'value.c2.title', descKey: 'value.c2.desc' },
  { icon: 'ri-shield-check-line', titleKey: 'value.c3.title', descKey: 'value.c3.desc' },
  { icon: 'ri-truck-line', titleKey: 'value.c4.title', descKey: 'value.c4.desc' },
];

export default function ValueProps() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            {t('value.title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">{t('value.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CARDS.map((card) => (
            <div
              key={card.titleKey}
              className="rounded-lg border border-background-200 bg-background-50 p-6 transition-transform hover:-translate-y-1"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 mb-4">
                <i className={`${card.icon} text-2xl`} />
              </span>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">
                {t(card.titleKey)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{t(card.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}